import type { LayoutApp } from '@typings/layout.ts';
import type { FloorLike, StructureLike } from '@typings/utils.ts';
import { StateObj } from '@utils/stateObj.ts';

type LevelIndicatorConfig = {
  deepLinkProps?: {
    disableZoomToExplorePopup?: string;
  };
};

type FloorChangePayload = {
  floor: FloorLike | null;
  structure: StructureLike | null;
};

function create(app: LayoutApp, config: LevelIndicatorConfig) {
  const init = () => {};
  const widgetState = new StateObj<{
    showLevelIndicator: boolean;
    isInitialLoad: boolean;
    structure: StructureLike | null;
    floor: FloorLike | null;
  }>({
    showLevelIndicator: true,
    isInitialLoad: true,
    structure: null,
    floor: null,
  });

  const setShowLevelIndicator = (showLevelIndicator = true) => {
    widgetState.update({ showLevelIndicator });
    if (!showLevelIndicator) {
      widgetState.update({ isInitialLoad: false });
    }
  };
  // Although we no longer register a widget here,
  // because users may depenend on this message, we continue to
  // to send it from this plugin which is loaded for many versions of Wayfinder
  app.bus.on('map/mapReadyToShow', () => {
    if (config.deepLinkProps?.disableZoomToExplorePopup !== 'true') {
      if (app.env.isMobile()) {
        app.bus.send('toast/show', {
          variant: 'info',
          message: app.gt()('levelIndicator:Zoom to explore the map'),
          iconName: 'info',
          top: '-3vh',
        });
      }
    }
  });

  app.bus.on<FloorChangePayload>('map/floorChanged', ({ structure, floor }) => {
    if (structure) {
      widgetState.update({ structure, floor, showLevelIndicator: true });
    }
  });

  app.bus.on('poiDetails/showPoi', () => setShowLevelIndicator());

  return {
    init,
    getWidgetState: () => widgetState.getState(),
  };
}

export { create };
